<!--
 * @Author: pyy
 * @Date: 2022-09-16
 * @Description: 项目统计-饼状图
-->
<template>
	<div class="pie-chart h100 pdb10"
		 ref="pieChart">
		<div v-for="item in num"
			 :key="item"
			 ref="myChart"
			 class="myChart"></div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import * as API from '@/api/FormManager/FormManager'
import { mapState } from 'vuex'
import { html2canvasExport } from '@/utils/tools'

export default {
	props: {
		apiParams: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			num: 1,
			optionsList: [],
			chartList: [],
		}
	},
	created() {},
	mounted() {
		window.addEventListener('resize', () => {
			setTimeout(() => {
				for (let index = 0; index < this.num; index++) {
					if (!!this.chartList[index]) {
						this.chartList[index].resize()
					}
				}
			}, 200)
		})
	},
	methods: {
		_getData() {
			API.getProjectStatisticsToPieChart(this.apiParams).then((res) => {
				if (!!res.data) {
					// 类型
					let typeArr = ['plan', 'declare', 'examine', 'actual']
					// 图表数量
					this.num = typeArr.length

					const dataArr = typeArr.map((item) => {
						let keys = res.data[item] // {yhq: '0', bhq: '0', fdx: '0'}
						let area = {}
						let areaValue = []
						let areaName = []
						// 遍历区域别名
						Object.keys(keys).map((k) => {
							area = this.projectDict.xmgsqy.find(
								(i) => i.alias === k
							)
							areaValue.push(keys[k])
							areaName.push(area.sname)
						})
						return {
							title: this.outputOptions[item],
							areaValue, // ['0', '0', '0']
							areaName, // ['瑶海区', '包河区', '肥东县']
						}
					})

					this.optionsList = []
					this.chartList = []

					dataArr.map((item) => {
						const { title, areaValue, areaName } = item
						const colorArr = [
							'#00b2ee',
							'#38bf98',
							'#ffcc00',
							'#ff6600',
						]
						this.optionsList.push({
							title: {
								text: title,
								left: 'center',
								top: '15',
								textStyle: {
									fontSize: 18,
									fontWeight: 'bolder',
									color: '#1e1e1e',
								},
							},
							tooltip: {
								trigger: 'item',
							},
							color: colorArr,
							legend: {
								orient: 'vertical',
								top: 'middle',
								right: '3%',
								itemWidth: 20,
								itemHeight: 20,
								textStyle: {
									color: '#666',
								},
							},
							toolbox: {
								show: true,
								feature: {
									mark: {
										show: true,
									},
									saveAsImage: {
										show: true,
										pixelRatio: 1,
										title: '保存为图片',
										type: 'png',
										lang: ['点击保存'],
										name: `东部新中心建设项目${title}饼状图`,
									},
								},
							},
							series: [
								{
									type: 'pie',
									radius: '55%',
									center: ['35%', '55%'],
									label: {
										show: true,
										formatter:
											'{b}' +
											'\n\r' +
											'{c}' +
											(this.apiParams.unit == 0
												? '元'
												: '万元'),

										lineHeight: 18,
									},
									data: [
										...areaName.map((name, index) => {
											return {
												name: name + title,
												value: areaValue[index],
												label: {
													color: colorArr[index],
												},
											}
										}),
									],
								},
							],
							// dataset: {
							// 	source: [
							// 	    ['瑶海区', 41.1],
							// 	    ['包河区', 86.5],
							// 	    ['肥东县', 24.1],
							// 	]
							// },
						})
					})

					setTimeout(() => {
						this.initChart()
					}, 200)
				}
			})
		},

		initChart() {
			this.optionsList.map((item, index) => {
				const chartItem = echarts.init(this.$refs.myChart[index])
				chartItem.setOption(item, true)
				this.chartList.push(chartItem)
			})
		},

		download() {
			if (this.$refs.pieChart) {
				html2canvasExport(
					this.$refs.pieChart,
					'东部新中心建设项目产值统计图'
				)
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		// 产值
		outputOptions() {
			return {
				plan: '计划完成产值',
				declare: '申报完成产值',
				examine: '审核完成产值',
				actual: '实际付款',
			}
		},
	},
	watch: {
		apiParams: {
			handler(newVal) {
				this._getData()
			},
			deep: true,
		},
	},
}
</script>

<style lang="less" scoped>
.pie-chart {
	display: flex;
	flex-wrap: wrap;
	overflow-y: auto;
	background-color: #fff;
	.myChart {
		width: 50%;
		// height: 377px;
		height: 50%;
		border: 1px solid #ccc;
	}
}
</style>